// ─────────────────────────────────────────────────────────────
// Common API file. Every network call in the app goes through here,
// so the base URL lives in exactly one place (REACT_APP_API_URL in .env).
// ─────────────────────────────────────────────────────────────
import axios from "axios";
import { API_BASE_URL } from "../config/env";

export const apiUrl = (path = "") =>
  `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

/**
 * Drop-in replacement for fetch() that prefixes the base URL.
 *   const res = await apiFetch("/getStore", { method: "GET" });
 */
export const apiFetch = (path, options) => fetch(apiUrl(path), options);

/**
 * Axios instance with the base URL already set.
 *   const { data } = await api.get("/getStoreTransaction/123");
 */
export const api = axios.create({ baseURL: API_BASE_URL });

export default api;
